<template>
  <div class="ding-login-container">
    <div class="ding-login-content">
      <h1 class="ding-login-title">钉钉扫码激活雪亮工程处理工具</h1>
      <div id="self_defined_element" class="self-defined-classname"></div>
      <div class="ding-login-tips">请使用钉钉App扫码登录</div>
    </div>
  </div>
</template>

<script>
const clientId = "dingmblxwodwoi6sp6qi";
const corpId = "ding6b6b2e8abe84e18c35c2f4657eb6378f";
const redirectUri = window.location.origin;
import request from '@/utils/request'
export default {
  name: "XueLiangLogin",
  data() {
    return {};
  },
  mounted() {
    let params = this.getUrlParams();
    let registrationCode = null;
    if(!params.registrationCode){
      window.location.href = redirectUri;
      return;
    }else{
      registrationCode = params.registrationCode
    }
    window.DTFrameLogin(
      {
        id: "self_defined_element",
        width: 300,
        height: 300,
      },
      {
        redirect_uri: encodeURIComponent(
          redirectUri
        ),
        client_id: clientId,
        scope: "openid corpid",
        response_type: "code",
        corpId: corpId,
        prompt: "consent",
      },
      async (loginResult) => {
        const {authCode } = loginResult;
        // 这里可以直接进行重定向
        // window.location.href = redirectUrl;
        // 也可以在不跳转页面的情况下，使用code进行授权
        try {
          const res = await request.post('/auth/xueliangDingLogin', {
            code: authCode,
            remark:params.remark,
            registrationCode: registrationCode
          })
          if(res.error){
            this.$message.error(res.error);
          } else{
            window.parent.postMessage(res, '*');
          }
   
        } catch (error) {
          
          this.$message.error(error);
        }
      },
      (errorMsg) => {
        // 这里一般需要展示登录失败的具体原因,可以使用toast等轻提示
        this.$message.error(errorMsg);
      }
    );
  },
  methods: {
       // 解析 URL 参数的工具函数
      getUrlParams() {
        const params = {};
        const search = window.location.search.slice(1); // 去掉?号
        if (search) {
          search.split('&').forEach(item => {
            const [key, value] = item.split('=');
            params[key] = decodeURIComponent(value); // 解码参数
          });
        }
        return params;
      }
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.ding-login-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.ding-login-content {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 90%;
  max-width: 500px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.self-defined-classname {
  width: 300px;
  height: 300px;
}
.ding-login-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
}

.ding-login-qrcode {
  margin-bottom: 20px;
}

.ding-login-tips {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.ding-login-status {
  font-size: 14px;
  color: #1890ff;
  margin-top: 10px;
}
</style>
